(() => {
  const selector = ".collection-title-highlight--enabled";

  const prepareBlock = (block) => {
    if (!block || block.dataset.collectionHighlightPrepared === "true") return;
    block.dataset.collectionHighlightPrepared = "true";

    let textElements = Array.from(
      block.querySelectorAll(
        ".collection-title-highlight__content :is(h1, h2, h3, h4, h5, h6, p)",
      ),
    );

    if (!textElements.length) {
      const fallback = Array.from(
        block.querySelectorAll(".collection-title-highlight__content *"),
      ).find(
        (element) =>
          !element.classList.contains(
            "collection-title-highlight__white-layer",
          ) &&
          element.children.length === 0 &&
          element.textContent.trim().length > 0,
      );
      if (fallback) textElements = [fallback];
    }

    for (const element of textElements) {
      if (element.classList.contains("collection-title-highlight__white-layer"))
        continue;
      element.classList.add("collection-title-highlight__base-layer");

      let overlay = element.querySelector(
        ":scope > .collection-title-highlight__white-layer",
      );
      if (!overlay) {
        overlay = document.createElement("span");
        overlay.className = "collection-title-highlight__white-layer";
        overlay.setAttribute("aria-hidden", "true");
        const sourceNodes = Array.from(element.childNodes).filter(
          (node) =>
            !(
              node.nodeType === Node.ELEMENT_NODE &&
              node.classList?.contains(
                "collection-title-highlight__white-layer",
              )
            ),
        );
        for (const node of sourceNodes)
          overlay.appendChild(node.cloneNode(true));
        element.appendChild(overlay);
      }
    }

    const show = () =>
      block.classList.add("collection-title-highlight--visible");
    if (!block.classList.contains("collection-title-highlight--animated")) {
      show();
      return;
    }
    if (!("IntersectionObserver" in window)) {
      show();
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        show();
        observer.disconnect();
      },
      { threshold: 0.15, rootMargin: "0px 0px -5% 0px" },
    );
    observer.observe(block);
  };

  const initialiseAll = (root = document) => {
    if (root.matches?.(selector)) prepareBlock(root);
    root.querySelectorAll?.(selector).forEach(prepareBlock);
  };

  const initialise = () => initialiseAll(document);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }
  document.addEventListener("shopify:section:load", (event) =>
    initialiseAll(event.target),
  );

  const mutationObserver = new MutationObserver((mutations) => {
    if (
      mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.(selector) || node.querySelector?.(selector)),
        ),
      )
    ) {
      requestAnimationFrame(initialise);
    }
  });
  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  const dynamicTextSelector = ".dynamic-text-highlight--enabled";
  const prepareDynamicText = (block) => {
    if (!block || block.dataset.dynamicTextHighlightPrepared === "true") return;
    block.dataset.dynamicTextHighlightPrepared = "true";
    let textElements = Array.from(
      block.querySelectorAll(
        ".dynamic-text-highlight__content :is(h1, h2, h3, h4, h5, h6, p)",
      ),
    );
    if (!textElements.length) {
      const fallback = Array.from(
        block.querySelectorAll(".dynamic-text-highlight__content *"),
      ).find(
        (element) =>
          element.children.length === 0 && element.textContent.trim(),
      );
      if (fallback) textElements = [fallback];
    }
    for (const element of textElements) {
      element.classList.add("dynamic-text-highlight__base-layer");
    }
    block.classList.add("dynamic-text-highlight--visible");
  };
  const initialiseDynamicText = (root = document) => {
    if (root.matches?.(dynamicTextSelector)) prepareDynamicText(root);
    root.querySelectorAll?.(dynamicTextSelector).forEach(prepareDynamicText);
  };
  initialiseDynamicText();
  document.addEventListener("shopify:section:load", (event) =>
    initialiseDynamicText(event.target),
  );
  const dynamicTextObserver = new MutationObserver((mutations) => {
    if (
      mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.(dynamicTextSelector) ||
              node.querySelector?.(dynamicTextSelector)),
        ),
      )
    ) {
      requestAnimationFrame(() => initialiseDynamicText(document));
    }
  });
  dynamicTextObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
